import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ProductDetailsActionsContainerStyles {
    container?: InjectableCss;
    qtyWrapper?: InjectableCss;
    priceWrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
}

const styles: ProductDetailsActionsContainerStyles = {
    container: {
        css: css`
            display: flex;
            padding-bottom: 10px;
            flex-wrap: wrap;
        `,
    },
    qtyWrapper: {
        css: css`
            flex-basis: 65px;
            margin-right: 10px;
        `,
    },
    priceWrapper: {
        css: css`
            flex-basis: 100%;
            margin-bottom: 10px;
        `,
    },
    addToCartWrapper: {
        css: css`
            flex-basis: calc(100% - 75px);
        `,
    },
};

export const productDetailsActionsContainerStyles = styles;

const ProductDetailsActionsContainer: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.priceWrapper}>
                <Zone contentId={id} zoneName="uom" />
            </StyledWrapper>
            <StyledWrapper {...styles.qtyWrapper}>
                <Zone contentId={id} zoneName="qty" />
            </StyledWrapper>
            <StyledWrapper {...styles.addToCartWrapper}>
                <Zone contentId={id} zoneName="addToCart" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const productDetailsActionsContainer: WidgetModule = {
    component: ProductDetailsActionsContainer,
    definition: {
        group: "Common",
    },
};

export default productDetailsActionsContainer;
